import {
  cpcBackOfficeNavMenu,
  defaultNavMenu,
  lenderNavMenu,
  merchantChannelAgentNavMenu,
  merchantGroupNavMenu,
  superAdminNavMenu,
} from '@/components/views/DynamicPageView/config/layoutScheme/navMenuSchemes/defaultNavMenu';
import { PAGE_A2A_PAYMENT } from '@/components/views/DynamicPageView/config/layoutScheme/pageSchemes/A2APayment';
import { PAGE_A2A_PAYMENT_LIST } from '@/components/views/DynamicPageView/config/layoutScheme/pageSchemes/A2APaymentList';
import { PAGE_ACCOUNT } from '@/components/views/DynamicPageView/config/layoutScheme/pageSchemes/Account';
import { PAGE_AGENT } from '@/components/views/DynamicPageView/config/layoutScheme/pageSchemes/Agent';
import { PAGE_APPLICATION } from '@/components/views/DynamicPageView/config/layoutScheme/pageSchemes/Application';
import { PAGE_AUTO_LOAN } from '@/components/views/DynamicPageView/config/layoutScheme/pageSchemes/AutoLoan';
import { PAGE_AUTO_LOAN_LIST } from '@/components/views/DynamicPageView/config/layoutScheme/pageSchemes/AutoLoanList';
import { PAGE_BORROWER } from '@/components/views/DynamicPageView/config/layoutScheme/pageSchemes/Borrower';
import { PAGE_BORROWER_LIST } from '@/components/views/DynamicPageView/config/layoutScheme/pageSchemes/BorrowerList';
import { PAGE_CARD } from '@/components/views/DynamicPageView/config/layoutScheme/pageSchemes/Card';
import { PAGE_CARD_PAYMENT } from '@/components/views/DynamicPageView/config/layoutScheme/pageSchemes/CardPayment';
import { PAGE_CARD_PAYMENT_LIST } from '@/components/views/DynamicPageView/config/layoutScheme/pageSchemes/CardPaymentList';
import { PAGE_CHANNEL } from '@/components/views/DynamicPageView/config/layoutScheme/pageSchemes/Channel';
import { PAGE_CHECKOUT_SESSION } from '@/components/views/DynamicPageView/config/layoutScheme/pageSchemes/CheckoutSession';
import { PAGE_CHECKOUT_SESSION_LIST } from '@/components/views/DynamicPageView/config/layoutScheme/pageSchemes/CheckoutSessionList';
import { PAGE_CONSUMER_LOAN } from '@/components/views/DynamicPageView/config/layoutScheme/pageSchemes/ConsumerLoan';
import { PAGE_CONSUMER_LOAN_LIST } from '@/components/views/DynamicPageView/config/layoutScheme/pageSchemes/ConsumerLoanList';
import { PAGE_CREDIT_CARD } from '@/components/views/DynamicPageView/config/layoutScheme/pageSchemes/CreditCard';
import { PAGE_CREDIT_CARD_LIST } from '@/components/views/DynamicPageView/config/layoutScheme/pageSchemes/CreditCardList';
import { PAGE_CREDIT_LINE } from '@/components/views/DynamicPageView/config/layoutScheme/pageSchemes/CreditLine';
import { PAGE_CREDIT_LINE_LIST } from '@/components/views/DynamicPageView/config/layoutScheme/pageSchemes/CreditLineList';
import { PAGE_DOCUMENTS_VALIDATION } from '@/components/views/DynamicPageView/config/layoutScheme/pageSchemes/DocumentsValidation';
import { PAGE_FUNNEL } from '@/components/views/DynamicPageView/config/layoutScheme/pageSchemes/Funnel';
import { PAGE_HOME } from '@/components/views/DynamicPageView/config/layoutScheme/pageSchemes/Home';
import { PAGE_INTEGRATIONS } from '@/components/views/DynamicPageView/config/layoutScheme/pageSchemes/Integrations';
import { PAGE_MERCHANT } from '@/components/views/DynamicPageView/config/layoutScheme/pageSchemes/Merchant';
import { PAGE_MERCHANT_LIST } from '@/components/views/DynamicPageView/config/layoutScheme/pageSchemes/MerchantList';
import { PAGE_ORDER } from '@/components/views/DynamicPageView/config/layoutScheme/pageSchemes/Order';
import { PAGE_ORDER_LIST } from '@/components/views/DynamicPageView/config/layoutScheme/pageSchemes/OrderList';
import { PAGE_PAY_BY_LINK } from '@/components/views/DynamicPageView/config/layoutScheme/pageSchemes/PayByLink';
import { PAGE_PAY_BY_LINK_LIST } from '@/components/views/DynamicPageView/config/layoutScheme/pageSchemes/PayByLinkList';
import { PAGE_PAYOUT } from '@/components/views/DynamicPageView/config/layoutScheme/pageSchemes/Payout';
import { PAGE_PAYOUTS_LIST } from '@/components/views/DynamicPageView/config/layoutScheme/pageSchemes/PayoutsList';
import { PAGE_PRICING_CREATE } from '@/components/views/DynamicPageView/config/layoutScheme/pageSchemes/PricingCreate';
import { PAGE_PRICING_EDITOR } from '@/components/views/DynamicPageView/config/layoutScheme/pageSchemes/PricingEditor';
import { PAGE_PRICINGS_LIST } from '@/components/views/DynamicPageView/config/layoutScheme/pageSchemes/PricingsList';
import { PAGE_REPORT } from '@/components/views/DynamicPageView/config/layoutScheme/pageSchemes/Report';
import { PAGE_REPORTS_LIST } from '@/components/views/DynamicPageView/config/layoutScheme/pageSchemes/ReportsList';
import { PAGE_SIMULATOR } from '@/components/views/DynamicPageView/config/layoutScheme/pageSchemes/Simulator';
import { PAGE_USERS } from '@/components/views/DynamicPageView/config/layoutScheme/pageSchemes/Users';
import { ALL_APP_USER_TYPES, APP_USER_TYPES } from '@/config/config';
import { PageScheme } from '@/config/types';

export const pageSchemes: PageScheme[] = [
  PAGE_HOME,
  PAGE_ACCOUNT,
  PAGE_FUNNEL,
  PAGE_CONSUMER_LOAN_LIST,
  PAGE_CONSUMER_LOAN,
  PAGE_CREDIT_LINE_LIST,
  PAGE_CREDIT_LINE,
  PAGE_CREDIT_CARD_LIST,
  PAGE_CARD,
  PAGE_AUTO_LOAN_LIST,
  PAGE_AUTO_LOAN,
  PAGE_ORDER_LIST,
  PAGE_ORDER,
  PAGE_PAY_BY_LINK_LIST,
  PAGE_PAY_BY_LINK,
  PAGE_MERCHANT_LIST,
  PAGE_MERCHANT,
  PAGE_BORROWER,
  PAGE_BORROWER_LIST,
  PAGE_AGENT,
  PAGE_CHANNEL,
  PAGE_PAYOUT,
  PAGE_PAYOUTS_LIST,
  PAGE_PRICINGS_LIST,
  PAGE_PRICING_EDITOR,
  PAGE_PRICING_CREATE,
  PAGE_APPLICATION,
  PAGE_CHECKOUT_SESSION_LIST,
  PAGE_CHECKOUT_SESSION,
  PAGE_SIMULATOR,
  PAGE_A2A_PAYMENT,
  PAGE_A2A_PAYMENT_LIST,
  PAGE_CARD_PAYMENT,
  PAGE_CARD_PAYMENT_LIST,
  PAGE_REPORTS_LIST,
  PAGE_REPORT,
  PAGE_INTEGRATIONS,
  PAGE_USERS,
  PAGE_DOCUMENTS_VALIDATION,
  PAGE_CREDIT_CARD,
  PAGE_CREDIT_CARD_LIST,
];

export const navMenuSchemesByUserType = [
  {
    userTypes: [APP_USER_TYPES.LENDER],
    navMenu: lenderNavMenu,
    showSuperSearchBar: true,
  },
  {
    userTypes: [APP_USER_TYPES.ADMIN, APP_USER_TYPES.SUPER_ADMIN],
    navMenu: superAdminNavMenu,
    showSuperSearchBar: true,
  },
  {
    userTypes: [APP_USER_TYPES.MERCHANT, APP_USER_TYPES.CHANNEL, APP_USER_TYPES.AGENT],
    navMenu: merchantChannelAgentNavMenu,
    showSuperSearchBar: true,
  },
  {
    userTypes: [APP_USER_TYPES.MERCHANT_GROUP],
    navMenu: merchantGroupNavMenu,
    showSuperSearchBar: true,
  },
  {
    userTypes: [APP_USER_TYPES.THIRD_PARTY_VALIDATION],
    navMenu: defaultNavMenu,
    showSuperSearchBar: false,
  },
  {
    userTypes: [APP_USER_TYPES.CPC_BACK_OFFICE],
    navMenu: cpcBackOfficeNavMenu,
    showSuperSearchBar: true,
  },
  {
    userTypes: [...ALL_APP_USER_TYPES],
    navMenu: defaultNavMenu,
    showSuperSearchBar: true,
  },
];
